const PermissionsService = {
    hasPermission: (requiredRoles: string[], roles: string[] = []): boolean => {
        if (!roles) return false;

        // Admin / Superuser role auto-bypass
        const isAdminOrSuperuser = roles.some(role => 
            ['superuser', 'admin', 'superadmin'].includes((role || '').toLowerCase())
        );
        if (isAdminOrSuperuser) {
            return true;
        }

        const requiredLower = requiredRoles.map(rr => rr.toLowerCase());
        return roles.some(role => requiredLower.includes((role || '').toLowerCase()));
    }
}

export default PermissionsService;